import BackHeader from "@components/header/BackHeader";
import styled from "@emotion/styled";
import { FormProvider, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { passwordSchema } from "@libs/zod/zodVaildation";
import { useNavigate, useSearchParams } from "react-router-dom";
import FindEmail from "./components/FindEmail";
import FindPassword from "./components/FindPassword";
import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";

export interface IFormInput {
  findemail: string;
  newpassword: string;
  newpasswordConfirm: string;
  login_id: string;
  password: string;
  passwordConfirm: string;
  member_id: string;
}

export default function FindPasswordPage() {
  const [step, setStep] = useState(0);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const verificationCode = searchParams.get("verificationCode");

  useEffect(() => {
    if (verificationCode) {
      setStep(1);
    }
  }, [verificationCode]);

  const methods = useForm<IFormInput>({
    resolver: zodResolver(passwordSchema),
    mode: "onChange",
    reValidateMode: "onChange",
    shouldUnregister: false,

    defaultValues: {
      findemail: "",
      newpassword: "",
      newpasswordConfirm: "",
      login_id: "",
      password: "",
      passwordConfirm: "",
      member_id: "",
    },
  });

  const handleBackEvent = () => {
    if (step === 0) {
      navigate(-1); // 첫 번째 단계일 때, 이전 페이지로
    } else {
      setStep(0); // 두 번째 단계일 때, 첫 번째 단계로 이동
    }
  };

  // verificationCode가있으면 스탭이동
  useEffect(() => {
    if (searchParams.get("verificationCode")) {
      setStep(1);
    }
  }, [searchParams]);

  const tabList = [
    { component: <FindEmail setStep={setStep} /> },
    { component: <FindPassword /> },
  ];

  return (
    <>
      <BackHeader title="비밀번호 찾기" onClick={handleBackEvent} />
      <FormProvider {...methods}>
        <Container>{tabList[step].component}</Container>
      </FormProvider>
    </>
  );
}

const Container = styled.div(() => ({
  padding: "2rem",
}));
